<template lang='pug' src='./custom-modal-team.pug'></template>

<script>
export default {
  computed: {
    props () {
      return this.$store.state.modalProps
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-modal-team.vue?3bacc881